import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const ResponseTimeIcon = (props: SvgProps) => <Svg
  width={20}
  height={20}
  viewBox='0 0 20 20'
  fill='none'
  {...props}
>
  <Path
    d='M10.833 6.52706C10.833 6.06682 10.4599 5.69373 9.99965 5.69373C9.53942 5.69373 9.16632 6.06706 9.16632 6.5273C9.16632 7.7352 9.16632 8.65225 9.16632 9.86016C9.16632 10.3204 9.53942 10.6937 9.99965 10.6937H13.333C13.7932 10.6937 14.1663 10.3206 14.1663 9.86039C14.1663 9.40016 13.7932 9.02706 13.333 9.02706H10.833V6.52706Z'
    fill={props.color ?? '#4A535A'}
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M9.99935 3.33268C6.31745 3.33268 3.33268 6.31745 3.33268 9.99935C3.33268 13.3996 5.87828 16.2053 9.16767 16.6146C9.62439 16.6715 9.99935 17.0391 9.99935 17.4993C9.99935 17.9596 9.62517 18.3371 9.16718 18.2917C4.95552 17.8741 1.66602 14.3209 1.66602 9.99935C1.66602 5.39698 5.39698 1.66602 9.99935 1.66602C14.3209 1.66602 17.8741 4.95552 18.2917 9.16718C18.3371 9.62518 17.9596 9.99935 17.4993 9.99935C17.0391 9.99935 16.6715 9.62438 16.6146 9.16767C16.2053 5.87828 13.3996 3.33268 9.99935 3.33268Z'
    fill={props.color ?? '#4A535A'}
  />
  <Path
    d='M17.4993 13.3327C17.4993 14.2532 16.7532 14.9993 15.8327 14.9993C14.9122 14.9993 14.166 14.2532 14.166 13.3327C14.166 12.4122 14.9122 11.666 15.8327 11.666C16.7532 11.666 17.4993 12.4122 17.4993 13.3327Z'
    fill={props.color ?? '#4A535A'}
  />
  <Path
    d='M18.9882 17.525C19.1788 17.9439 18.7929 18.3327 18.3327 18.3327H13.3327C12.8724 18.3327 12.4866 17.9439 12.6771 17.525C13.1249 16.5406 14.3686 15.8327 15.8327 15.8327C17.2968 15.8327 18.5404 16.5406 18.9882 17.525Z'
    fill={props.color ?? '#4A535A'}
  />
</Svg>;

export default ResponseTimeIcon;
